export const optionsChartBarVendas = {
  title: {
    display: true,
    padding: 20,
    text: "Vendas por Grupo",
  },
  legend: {
    position: "bottom",
    // paddingBottom: 50,
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          padding: 25,
        },
      },
    ],
  },
  plugins: {
    datalabels: {
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};

export const optionsChartBarVendasY = {
  title: {
    display: true,
    padding: 20,
    text: "Vendas por Grupo",
    fontColor: "#FC68A2",
    fontSize: 20,
  },
  legend: {
    position: "bottom",
    // paddingBottom: 50,
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          padding: 25,
        },
      },
    ],
  },
  plugins: {
    datalabels: {
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};
